module.exports = __webpack_public_path__ + "media/icons/key-5-dark-534cc190.svg";